import { apiClient } from "@config/apiClient";
import { API_URL } from "@config/constants";
import { IPlaceAutocompleteResponse } from "@interfaces/places.interface";

class PlacesService {
  private URL = `${API_URL}/common/places`;

  /**
   * City predictions for LOCATION attributes. Triton proxies Google Places so the API key stays
   * server-side; `types=(cities)` and `language=en` are its defaults, so only the input is sent.
   */
  async getAutocomplete(input: string): Promise<IPlaceAutocompleteResponse> {
    const params = new URLSearchParams({ input });

    return apiClient.get(`${this.URL}/autocomplete/?${params.toString()}`);
  }
}

const placesService = new PlacesService();
export default placesService;
